const AppointmentType = Object.freeze({
  BLOOD_DRAW: 'blood draw',
  SCAN: 'scan',
})

export default AppointmentType